import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
} from "@mui/material";
import { FeeStatementRowDto } from "../../shared/dtos/studentFeeLedger/FeeStatementRowDto";
import { TransactionType } from "../../shared/enums/TransactionType";
import { formatDateForDisplay } from "../../helpers/dateHelpers";

interface TransactionTableProps {
  transactions: FeeStatementRowDto[];
}

const TransactionTable: React.FC<TransactionTableProps> = ({
  transactions,
}) => {
  if (!transactions || transactions.length === 0) {
    return (
      <Typography sx={{ color: "text.secondary", py: 4, textAlign: "center" }}>
        No transactions recorded for this period.
      </Typography>
    );
  }

  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ borderRadius: 1 }}
    >
      <Table
        sx={{ minWidth: 650 }}
        size="small"
        aria-label="student statement table"
      >
        <TableHead>
          <TableRow sx={{ bgcolor: "action.hover" }}>
            <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Description</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Reference</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Vote Head</TableCell>
            <TableCell align="right" sx={{ fontWeight: 700 }}>
              Debit (Invoice)
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 700 }}>
              Credit (Payment)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map((row, index) => {
            const isDebit = row.type === TransactionType.INVOICE;
            return (
              <TableRow key={index} hover>
                <TableCell>{formatDateForDisplay(row.date)}</TableCell>
                <TableCell>{row.description || "N/A"}</TableCell>
                <TableCell>{row.reference || "-"}</TableCell>
                <TableCell>
                  <Chip
                    label={row.type}
                    color={isDebit ? "warning" : "success"}
                    size="small"
                    variant="outlined"
                  />
                </TableCell>
                <TableCell>{row.voteHeadName || "-"}</TableCell>
                <TableCell
                  align="right"
                  sx={{
                    color: "error.main",
                    fontWeight: isDebit ? 700 : 400,
                  }}
                >
                  {isDebit ? Number(row.amount || 0).toLocaleString() : "-"}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    color: "success.main",
                    fontWeight: !isDebit ? 700 : 400,
                  }}
                >
                  {!isDebit ? Number(row.amount || 0).toLocaleString() : "-"}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionTable;
